/* global Swiper */
// **********************************************************
// Text Slider
// **********************************************************

const textSliderSwiperElements = document.querySelectorAll('[data-slider="text-slider"]');
const textSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    prevEl: '.swiper-button-next',
    nextEl: 'swiper-button-prev',
  },
};

textSliderSwiperElements.forEach((el) => {
  const textSliderParent = el.closest('.text-slider');
  const paginationElement = textSliderParent.querySelector('.swiper-pagination');
  const arrowRight = textSliderParent.querySelector('.arrow-right');
  const arrowLeft = textSliderParent.querySelector('.arrow-left');

  textSliderOptions.navigation.nextEl = arrowRight;
  textSliderOptions.navigation.prevEl = arrowLeft;
  textSliderOptions.pagination.el = paginationElement;

  // eslint-disable-next-line no-new
  new Swiper(el, textSliderOptions);
});
